export default ({
  data: {
    result: { id },
  },
}) => ({ addressID: id });
